import React from 'react';

import { TextInputStyled, Container, LeftIcon, RightIcon } from './TextInput.styled';
import { V2_COMPONENT_CLASS_NAME } from 'components/v2/common.styled';
import { getInputStates } from 'components/v2/utils';

import { Props } from './TextInput.types';

export const TextInput = ({
  id,
  role,
  helperTextId,
  labelId,
  inputRef,
  type = 'text',
  status = 'default',
  placeholder,
  required = false,
  spellCheck = false,
  autoComplete,
  value,
  onChange,
  onBlur,
  onKeyPress,
  onKeyDown,
  onFocus,
  leftIcon,
  className,
  fullWidth,
  backgroundColor,
  rightIcon,
  onRightIconClick,
  postfix,
  hideArrowsForNumberInput,
  ariaLabel,
  ariaControls,
  ariaExpanded,
  ariaAutocomplete,
  ariaHasPopup,
  max,
  step,
  maxLength
}: Props) => {
  const isFilled = Boolean(value);
  const { isDisabled, isReadOnly, isValid } = getInputStates(status);

  return (
    <Container className={className} $fullWidth={fullWidth}>
      {leftIcon && <LeftIcon>{leftIcon}</LeftIcon>}
      <TextInputStyled
        readOnly={isReadOnly}
        className={V2_COMPONENT_CLASS_NAME}
        type={type}
        role={role}
        $status={status}
        $isFilled={isFilled}
        id={id}
        ref={inputRef}
        disabled={isDisabled}
        placeholder={placeholder}
        spellCheck={spellCheck}
        autoComplete={autoComplete}
        $leftIcon={!!leftIcon}
        $rightIcon={!!rightIcon}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        required={required}
        aria-labelledby={labelId}
        aria-disabled={isDisabled}
        aria-invalid={!isValid}
        aria-readonly={isReadOnly}
        aria-errormessage={helperTextId}
        $backgroundColor={backgroundColor}
        hideArrowsForNumberInput={hideArrowsForNumberInput}
        aria-label={ariaLabel}
        aria-controls={ariaControls}
        aria-expanded={ariaExpanded}
        aria-autocomplete={ariaAutocomplete}
        aria-haspopup={ariaHasPopup}
        max={max}
        step={step}
        maxLength={maxLength}
      />
      {rightIcon && <RightIcon onClick={onRightIconClick}>{rightIcon}</RightIcon>}
      {postfix}
    </Container>
  );
};
